import React, { lazy, useEffect } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "../component/login";
import Otp from "../component/otp";
import PrivateRoute from "./privateRoute";
import ReferralCode from "../component/referralCode.js";
import { hasFantasyShareParams, openSharedFantasyLink } from "../utils/fantasyNavigation";

const Contest = lazy(() => import("../component/contest/contest.js"));
const Home = lazy(() => import("../component/home/home.js"));
const ToroAIchat = lazy(() => import("../chat/toroAIchat.js"));
const ContestDetails = lazy(() =>
  import("../component/contest/leagueDetails.js")
);

const ContestFantasyInfo = lazy(() =>
  import("../includes/contestFantasyInfo.js")
);
const ContestPortfolioPreview = lazy(() =>
  import("../component/contest/portfolioPreview.js")
);
const Selection = lazy(() =>
  import("../component/fantasyContest/selection.js")
);
const Lineup = lazy(() => import("../component/contest/lineup.js"));
const LineupCrypto = lazy(() => import("../component/contest/lineupCrypto.js"));
const Paperless = lazy(() => import("../component/paperless/paperless.js"));
const PortfolioPreview = lazy(() =>
  import("../component/paperless/portfolioPreview.js")
);
const PortfolioPreviewStockDetails = lazy(() =>
  import("../component/paperless/stockDetails.js")
);

const TradingInfoDetails = lazy(() =>
  import("../component/paperless/tradingInfoDetails.js")
);

const PortfolioStats = lazy(() =>
  import("../component/paperless/portfolioStats")
);
const CreatePortfolio = lazy(() =>
  import("../component/paperless/createPortfolio.js")
);
const ToroGeneratedPortfolioPreview = lazy(() =>
  import("../component/paperless/toroGeneratedPortfolioPreview")
);
const MarketPreview = lazy(() =>
  import("../component/paperless/marketPreview.js")
);
const PortfolioListing = lazy(() =>
  import("../component/paperless/portfolioListing.js")
);

const MultiRoundFantasy = lazy(() => import("../component/fantasy/fantasy.js"));
const MultiRoundCreateFantasy = lazy(() =>
  import("../component/fantasy/createFantasy.js")
);
const MultiRoundJoinFantasy = lazy(() =>
  import("../component/fantasy/joinFantasy.js")
);
const MultiRoundFantasyLeageDetails = lazy(() =>
  import("../component/fantasy/leageDetails.js")
);
const MultiRoundFantasyRoster = lazy(() =>
  import("../component/fantasy/roster.js")
);
const MultiRoundFantasyLineup = lazy(() =>
  import("../component/fantasy/lineup.js")
);
const MultiRoundFantasySelection = lazy(() =>
  import("../component/fantasy/selection.js")
);
const MultiRoundFantasyPortfolioDetails = lazy(() =>
  import("../component/fantasy/portfoloiPreview.js")
);
const MultiRoundMyFantasy = lazy(() =>
  import("../component/fantasy/myFantasy/fantasy.js")
);
const MultiRoundMyFantasyMatchUp = lazy(() =>
  import("../component/fantasy/myFantasy/matchUp.js")
);
const MultiRoundMyFantasyMatchUpDeatils = lazy(() =>
  import("../component/fantasy/myFantasy/matchUpDeatils.js")
);
const MultiRoundMyFantasyMyRoster = lazy(() =>
  import("../component/fantasy/myFantasy/myRoster.js")
);
const MultiRoundMyFantasyComplete = lazy(() =>
  import("../component/fantasy/myFantasy/complete.js")
);
const MultiRoundMyFantasyUpcoming = lazy(() =>
  import("../component/fantasy/myFantasy/upcoming.js")
);
const Fantasy = lazy(() => import("../component/fantasyContest/contest.js"));
const SingleFantasyInfo = lazy(() =>
  import("../component/fantasyContest/singleFantasyInfo.js")
);
const MyFantasy = lazy(() =>
  import("../component/fantasyContest/myContest/contest.js")
);
const MyFantasyDetails = lazy(() =>
  import("../component/fantasyContest/myContest/contestDetails.js")
);
const MyFantasyMatchup = lazy(() =>
  import("../component/fantasyContest/myContest/matchup.js")
);
const MyFantasyOpponent = lazy(() =>
  import("../component/fantasyContest/myContest/opponent.js")
);
const MyFantasyStanding1 = lazy(() =>
  import("../component/fantasyContest/myContest/standing.js")
);
const MyFantasyUpcomingDetails = lazy(() =>
  import("../component/fantasyContest/myContest/upcomingContest.js")
);

const MyFantasyComplete = lazy(() =>
  import("../component/fantasy/myFantasy/complete.js")
);
const MyFantasyUpcoming = lazy(() =>
  import("../component/fantasy/myFantasy/upcoming.js")
);

const Games = lazy(() => import("../component/games/games.js"));
const ContestGameDetails = lazy(() =>
  import("../component/games/contestGameDetails.js")
);
const GameTierSelection = lazy(() =>
  import("../component/games/gameTierSelection.js")
);
const MyFantasyMatchUp = lazy(() =>
  import("../component/fantasy/myFantasy/matchUp.js")
);
const MyFantasyStanding = lazy(() =>
  import("../component/fantasy/myFantasy/standing.js")
);
const MyFantasyPortfolioDetails = lazy(() =>
  import("../component/fantasy/myFantasy/portfolioDetails.js")
);
const MyFantasyEditStockPortfolio = lazy(() =>
  import("../component/fantasy/myFantasy/stockPreview.js")
);

const MyFantasyStockPortfolioSelection = lazy(() =>
  import("../component/fantasy/myFantasy/myFantasySelection.js")
);
const MyFantasyStockPortfolioPreview = lazy(() =>
  import("../component/fantasy/myFantasy/portfolioPreview.js")
);
const MyFantasyChat = lazy(() =>
  import("../component/fantasy/myFantasy/chat.js")
);
const PrivateFantasy = lazy(() =>
  import("../component/fantasy/privateFantasy.js")
);
const LeageDetails = lazy(() =>
  import("../component/fantasyContest/leagueDetails.js")
);
const CreateFantasy = lazy(() =>
  import("../component/fantasyContest/private/addContest.js")
);
const JoinFantasy = lazy(() =>
  import("../component/fantasyContest/private/joinContest.js")
);
const FantasyLineup = lazy(() =>
  import("../component/fantasyContest/lineup.js")
);
const FantasyLineupCrypto = lazy(() =>
  import("../component/fantasyContest/lineupCrypto.js")
);
const ContestSelection = lazy(() =>
  import("../component/contest/selection.js")
);
const AddPrivateContest = lazy(() =>
  import("../component/contest/private/addContest.js")
);
const InviteFriends = lazy(() =>
  import("../component/contest/private/inviteFriends.js")
);

const InviteFriends1 = lazy(() =>
  import("../component/fantasyContest/private/inviteFriends.js")
);
const InviteFriend = lazy(() => import("../component/profile/inviteFriend.js"));
const ContactUs = lazy(() => import("../page/contact.js"));
const JoinContest = lazy(() =>
  import("../component/contest/private/joinContest.js")
);
const FantasyBenchStock = lazy(() =>
  import("../component/fantasy/benchStock.js")
);
const FantasyPortfolioDetails = lazy(() =>
  import("../component/fantasyContest/portfolioPreview.js")
);
const PrivateContest = lazy(() =>
  import("../component/contest/private/contest.js")
);
const MyContest = lazy(() =>
  import("../component/contest/myContest/contest.js")
);
const MyContestDetails = lazy(() =>
  import("../component/contest/myContest/contestDetails.js")
);
const MyContestMatchup = lazy(() =>
  import("../component/contest/myContest/matchup.js")
);
const MyContestOpponent = lazy(() =>
  import("../component/contest/myContest/opponent.js")
);
const MyContestStanding = lazy(() =>
  import("../component/contest/myContest/standing.js")
);
const MyContestUpcoming = lazy(() =>
  import("../component/contest/myContest/upcoming.js")
);
const MyContestUpcomingDetails = lazy(() =>
  import("../component/contest/myContest/upcomingContest.js")
);
const MyContestComplete = lazy(() =>
  import("../component/contest/myContest/complete.js")
);

const MyProfile = lazy(() => import("../component/profile/myProfile.js"));
const AllCertificates = lazy(() =>
  import("../component/profile/allCertificates.js")
);
const RecentlyPlayed = lazy(() =>
  import("../component/profile/recentlyPlayed.js")
);
const SubscriptionHistory = lazy(() =>
  import("../component/profile/subscriptionHistory.js")
);
const AllBadges = lazy(() => import("../component/profile/allBadges.js"));
const Quiz = lazy(() => import("../component/quiz/quiz.js"));
const QuizRound = lazy(() => import("../component/quiz/quizRound.js"));
const QuizHistory = lazy(() => import("../component/quiz/quizHistory.js"));
// const GlobalLeaderboardLeague = lazy(() =>
//   import("../component/globalLeaderboard/league.js")
// );
// const GlobalLeaderboardContest = lazy(() =>
//   import("../component/globalLeaderboard/leaderBoard.js")
// );
// const LeaderboardContest = lazy(() =>
//   import("../component/globalLeaderboard/leaderBoard.js")
// );
// const LeaderboardLeague = lazy(() =>
//   import("../component/globalLeaderboard/leaderBoardLeague.js")
// );

const MyProfileRecentContest = lazy(() =>
  import("../component/profile/contest.js")
);
const Trophy = lazy(() => import("../component/profile/trophy.js"));

const MyProfileRecentFantasy = lazy(() =>
  import("../component/profile/fantasy.js")
);
const EditProfile = lazy(() => import("../component/profile/editProfile.js"));
const AvtarList = lazy(() => import("../component/profile/avtarList.js"));
const AvtarCategoryList = lazy(() =>
  import("../component/profile/avtarCategory.js")
);
const Subscription = lazy(() => import("../component/profile/subscription.js"));
const SelectPayment = lazy(() =>
  import("../component/profile/selectPayment.js")
);
const AppliedCoupon = lazy(() =>
  import("../component/profile/appliedCoupon.js")
);
const SelectVoucher = lazy(() => import("../component/profile/voucher.js"));
const Wallet = lazy(() => import("../component/profile/wallet.js"));
const Faq = lazy(() => import("../page/faq.js"));
const DailyRewards = lazy(() => import("../component/profile/rewards.js"));
const MyDailyRewards = lazy(() => import("../component/profile/myRewards.js"));
const DynamicContent = lazy(() => import("../page/dynamicContent.js"));
const Spinwheel = lazy(() => import("../component/profile/spinWheel.js"));

const Shop = lazy(() => import("../component/profile/shop.js"));
const TutorialVideos = lazy(() =>
  import("../component/profile/tutorialVideos.js")
);
const GiftCards = lazy(() => import("../component/profile/giftCards.js"));
const SavedVoucher = lazy(() => import("../component/profile/savedVoucher.js"));
// const Support = lazy(() => import("../page/support.js"));
const Rateing = lazy(() => import("../component/profile/rating.js"));

const ProductDetails = lazy(() =>
  import("../component/profile/productDetails.js")
);
const RedeemProduct = lazy(() =>
  import("../component/profile/redeemProduct.js")
);

const RalluBullsInsights = lazy(() => import("../page/dynamicInsight.js"));
// const EarnCoin = lazy(() => import("../component/profile/earnCoin.js"));
const Lms = lazy(() => import("../component/lms/lms.js"));
const LMSMyCourse = lazy(() => import("../component/lms/myCourse.js"));
const LMSPayment = lazy(() => import("../component/lms/payment.js"));
const LMSGuideRead = lazy(() => import("../component/lms/guide.js"));
const LMSGuideVideo = lazy(() => import("../component/lms/video.js"));
const LMSGuideQuestion = lazy(() => import("../component/lms/mcq.js"));
const LMSGuideDownload = lazy(() => import("../component/lms/download.js"));
const News = lazy(() => import("../component/news/news.js"));
const Community = lazy(() => import("../component/community/community.js"));
const LMSCourseDetails = lazy(() =>
  import("../component/lms/courseDetails.js")
);
const LMSGuideCommon = lazy(() => import("../component/lms/common.js"));

const SharedRouteFallback = ({ deviceToken }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("Token");
  const hasShare = hasFantasyShareParams(location.search, location.pathname);

  useEffect(() => {
    if (hasShare && token) {
      openSharedFantasyLink(navigate, location.search, location.pathname);
    } else if (!hasShare) {
      navigate(token ? "/home" : "/", { replace: true });
    }
  }, [hasShare, token, navigate, location.search, location.pathname]);

  if (hasShare && !token) {
    return <Login deviceToken={deviceToken} />;
  }

  return null;
};

function DefaultRoutes({ deviceToken }) {
  const routes = [
    { path: "/", element: <Login deviceToken={deviceToken} /> },
    // { path: "/register", element: <Login /> },
     { path: "/register", element: <Navigate to="/" /> }, // Redirect /register to /
    { path: "/referral", element: <ReferralCode deviceToken={deviceToken} /> }, // Redirect /referral to /
    { path: "/otp", element: <Otp /> },
    { path: "/home", element: <PrivateRoute Component={Home} /> },
    { path: "/toro-chat", element: <PrivateRoute Component={ToroAIchat} /> },
    { path: "/home/profile", element: <PrivateRoute Component={MyProfile} /> },
    {
      path: "/home/profile/badges",
      element: <PrivateRoute Component={AllBadges} />,
    },
    {
      path: "/home/profile/certificate",
      element: <PrivateRoute Component={AllCertificates} />,
    },
    {
      path: "/home/profile/recently-played",
      element: <PrivateRoute Component={RecentlyPlayed} />,
    },
    {
      path: "/home/profile/subscription-history",
      element: <PrivateRoute Component={SubscriptionHistory} />,
    },
    { path: "/news", element: <PrivateRoute Component={News} /> },
    { path: "/community", element: <PrivateRoute Component={Community} /> },
    {
      path: "/home/profile/plus/select-payment",
      element: <PrivateRoute Component={SelectPayment} />,
    },
    {
      path: "/home/profile/plus/applied-coupon",
      element: <PrivateRoute Component={AppliedCoupon} />,
    },
    {
      path: "/home/profile/plus/select-voucher",
      element: <PrivateRoute Component={SelectVoucher} />,
    },
    {
      path: "/home/profile/trophy",
      element: <PrivateRoute Component={Trophy} />,
    },
    {
      path: "/home/profile/invite",
      element: <PrivateRoute Component={InviteFriend} />,
    },
    {
      path: "/home/profile/contact-us",
      element: <PrivateRoute Component={ContactUs} />,
    },
    {
      path: "/home/profile/wallet",
      element: <PrivateRoute Component={Wallet} />,
    },
    {
      path: "/home/profile/setting/FAQS",
      element: <PrivateRoute Component={Faq} />,
    },
    {
      path: "/home/profile/earn/daily-rewards",
      element: <PrivateRoute Component={DailyRewards} />,
    },
    {
      path: "/home/profile/earn/rewards",
      element: <PrivateRoute Component={MyDailyRewards} />,
    },
    // {
    //   path: "/home/profile/support",
    //   element: <PrivateRoute Component={Support} />,
    // },
    {
      path: "/home/profile/rate",
      element: <PrivateRoute Component={Rateing} />,
    },
    // {
    //   path: "/home/profile/leaderboard/contest",
    //   element: <PrivateRoute Component={GlobalLeaderboardContest} />,
    // },
    // {
    //   path: "/home/profile/leaderboard/league",
    //   element: <PrivateRoute Component={GlobalLeaderboardLeague} />,
    // },
    {
      path: "/home/profile/spin-wheel",
      element: <PrivateRoute Component={Spinwheel} />,
    },
    { path: "/home/profile/shop", element: <PrivateRoute Component={Shop} /> },
    {
      path: "/home/profile/tutorial",
      element: <PrivateRoute Component={TutorialVideos} />,
    },
    {
      path: "/home/profile/shop/giftcard",
      element: <PrivateRoute Component={GiftCards} />,
    },
    {
      path: "/home/profile/shop/saved-voucher",
      element: <PrivateRoute Component={SavedVoucher} />,
    },
    {
      path: "/home/profile/shop/productdetail",
      element: <PrivateRoute Component={ProductDetails} />,
    },
    {
      path: "/home/profile/redeem-product",
      element: <PrivateRoute Component={RedeemProduct} />,
    },
    // Earn Coins section hidden for now
    // {
    //   path: "/home/profile/earn/coin",
    //   element: <PrivateRoute Component={EarnCoin} />,
    // },
    {
      path: "/home/profile/plus",
      element: <PrivateRoute Component={Subscription} />,
    },
    {
      path: "/home/edit-profile",
      element: <PrivateRoute Component={EditProfile} />,
    },
    {
      path: "/home/edit-profile/avtarCategorylist",
      element: <PrivateRoute Component={AvtarCategoryList} />,
    },
    {
      path: "/home/edit-profile/avtarlist/:id",
      element: <PrivateRoute Component={AvtarList} />,
    },
    {
      path: "/home/profile/recent-played",
      element: <PrivateRoute Component={MyProfileRecentContest} />,
    },
    {
      path: "/home/profile/recent-played-fantasy",
      element: <PrivateRoute Component={MyProfileRecentFantasy} />,
    },
    { path: "/contest/games", element: <PrivateRoute Component={Games} /> },
    {
      path: "/contest/games/contestdetails",
      element: <PrivateRoute Component={ContestGameDetails} />,
    },
    {
      path: "/contest/games/tierSelection",
      element: <PrivateRoute Component={GameTierSelection} />,
    },
    { path: "/lms", element: <PrivateRoute Component={Lms} /> },
    {
      path: "/lms/my-course",
      element: <PrivateRoute Component={LMSMyCourse} />,
    },
    {
      path: "/lms/course/:id",
      element: <PrivateRoute Component={LMSCourseDetails} />,
    },
    { path: "/lms/payment", element: <PrivateRoute Component={LMSPayment} /> },
    {
      path: "/lms/guide/:lessionId",
      element: <PrivateRoute Component={LMSGuideRead} />,
    },
    {
      path: "/lms/common",
      element: <PrivateRoute Component={LMSGuideCommon} />,
    },
    {
      path: "/lms/guide/:lessionId",
      element: <PrivateRoute Component={LMSGuideVideo} />,
    },
    {
      path: "/lms/guide",
      element: <PrivateRoute Component={LMSGuideQuestion} />,
    },
    {
      path: "/lms/guide-download",
      element: <PrivateRoute Component={LMSGuideDownload} />,
    },
    { path: "/contest", element: <PrivateRoute Component={Contest} /> },
    {
      path: "/contest/league/:id",
      element: <PrivateRoute Component={ContestDetails} />,
    },
    {
      path: "/contest/info",
      element: <PrivateRoute Component={ContestFantasyInfo} />,
    },
    {
      path: "/contest/selection",
      element: <PrivateRoute Component={ContestSelection} />,
    },
    { path: "/contest/lineup", element: <PrivateRoute Component={Lineup} /> },
    {
      path: "/contest/lineup/crypto",
      element: <PrivateRoute Component={LineupCrypto} />,
    },
    {
      path: "/contest/portfolio/preview",
      element: <PrivateRoute Component={ContestPortfolioPreview} />,
    },
    { path: "/contest/private", element: <PrivateRoute Component={Contest} /> },
    {
      path: "/contest/private/add",
      element: <PrivateRoute Component={AddPrivateContest} />,
    },
    {
      path: "/fantasy/invite-friend",
      element: <PrivateRoute Component={InviteFriends} />,
    },
    {
      path: "/contest/join",
      element: <PrivateRoute Component={JoinContest} />,
    },
    {
      path: "/contest/mycontest",
      element: <PrivateRoute Component={MyContest} />,
    },
    {
      path: "/contest/mycontest/details",
      element: <PrivateRoute Component={MyContestDetails} />,
    },
    {
      path: "/contest/mycontest/matchup",
      element: <PrivateRoute Component={MyContestMatchup} />,
    },
    {
      path: "/contest/mycontest/opponent",
      element: <PrivateRoute Component={MyContestOpponent} />,
    },
    {
      path: "/contest/mycontest/standing",
      element: <PrivateRoute Component={MyContestStanding} />,
    },
    {
      path: "/contest/mycontest/upcoming",
      element: <PrivateRoute Component={MyContest} />,
    },
    {
      path: "/contest/mycontest/upcoming/details/:contest_id",
      element: <PrivateRoute Component={MyContestUpcomingDetails} />,
    },
    {
      path: "/contest/mycontest/complete",
      element: <PrivateRoute Component={MyContest} />,
    },
    { path: "/paper", element: <PrivateRoute Component={Paperless} /> },
    {
      path: "/paper/createportfolio",
      element: <PrivateRoute Component={CreatePortfolio} />,
    },
    {
      path: "/toro-generated-portfolio-preview/:id",
      element: <PrivateRoute Component={ToroGeneratedPortfolioPreview} />,
    },
    {
      path: "/home/marketPreview",
      element: <PrivateRoute Component={MarketPreview} />,
    },
    {
      path: "/paper/portfoliolist",
      element: <PrivateRoute Component={PortfolioListing} />,
    },
    {
      path: "/paper/portfolio/preview",
      element: <PrivateRoute Component={PortfolioPreview} />,
    },
    {
      path: "/paper/portfolio/preview/stockdetails",
      element: <PrivateRoute Component={PortfolioPreviewStockDetails} />,
    },
    {
      path: "/paper/info/trading-rules",
      element: <PrivateRoute Component={TradingInfoDetails} />,
    },
    {
      path: "/paper/portfolio/stats",
      element: <PrivateRoute Component={PortfolioStats} />,
    },
    {
      path: "/fantasy/multi-round",
      element: <PrivateRoute Component={MultiRoundFantasy} />,
    },
    {
      path: "/fantasy/multi-round/leaguedetail/:id",
      element: <PrivateRoute Component={MultiRoundFantasyLeageDetails} />,
    },
    {
      path: "/fantasy/multi-round/private",
      element: <PrivateRoute Component={MultiRoundFantasy} />,
    },
    {
      path: "/fantasy/multi-round/create",
      element: <PrivateRoute Component={MultiRoundCreateFantasy} />,
    },
    {
      path: "/fantasy/multi-round/join",
      element: <PrivateRoute Component={MultiRoundJoinFantasy} />,
    },
    {
      path: "/fantasy/multi-round/roster",
      element: <PrivateRoute Component={MultiRoundFantasyRoster} />,
    },
    {
      path: "/fantasy/multi-round/lineup",
      element: <PrivateRoute Component={MultiRoundFantasyLineup} />,
    },
    {
      path: "/fantasy/multi-round/selection",
      element: <PrivateRoute Component={MultiRoundFantasySelection} />,
    },
    {
      path: "/fantasy/multi-round/portfolioPreview",
      element: <PrivateRoute Component={MultiRoundFantasyPortfolioDetails} />,
    },
    {
      path: "/fantasy/multi-round/myfantasy",
      element: <PrivateRoute Component={MultiRoundMyFantasy} />,
    },
    {
      path: "/fantasy/myfantasy/multi-round/matchup",
      element: <PrivateRoute Component={MultiRoundMyFantasyMatchUp} />,
    },
    {
      path: "/fantasy/myfantasy/multi-round/matchup-details",
      element: <PrivateRoute Component={MultiRoundMyFantasyMatchUpDeatils} />,
    },
    {
      path: "/fantasy/myfantasy/multi-round/my-roster",
      element: <PrivateRoute Component={MultiRoundMyFantasyMyRoster} />,
    },
    {
      path: "/fantasy/multi-round/myfantasy/complete",
      element: <PrivateRoute Component={MultiRoundMyFantasyComplete} />,
    },
    {
      path: "/fantasy/multi-round/myfantasy/upcoming",
      element: <PrivateRoute Component={MultiRoundMyFantasyUpcoming} />,
    },
    { path: "/fantasy", element: <PrivateRoute Component={Fantasy} /> },
    {
      path: "/fantasy/info",
      element: <PrivateRoute Component={SingleFantasyInfo} />,
    },
    {
      path: "/fantasy/leaguedetail/:id",
      element: <PrivateRoute Component={LeageDetails} />,
    },
    {
      path: "/fantasy/lineup",
      element: <PrivateRoute Component={FantasyLineup} />,
    },
    {
      path: "/fantasy/lineup/crypto",
      element: <PrivateRoute Component={FantasyLineupCrypto} />,
    },
    {
      path: "/fantasy/selection",
      element: <PrivateRoute Component={Selection} />,
    },
    {
      path: "/fantasy/bench-stock",
      element: <PrivateRoute Component={FantasyBenchStock} />,
    },
    {
      path: "/fantasy/portfolio",
      element: <PrivateRoute Component={FantasyPortfolioDetails} />,
    },
    {
      path: "/fantasy/create",
      element: <PrivateRoute Component={CreateFantasy} />,
    },
    {
      path: "/fantasy/join",
      element: <PrivateRoute Component={JoinFantasy} />,
    },
    { path: "/fantasy/private", element: <PrivateRoute Component={Fantasy} /> },
    {
      path: "/fantasy/myfantasy",
      element: <PrivateRoute Component={MyFantasy} />,
    },
    {
      path: "/fantasy/myfantasy/upcoming",
      element: <PrivateRoute Component={MyFantasy} />,
    },
    {
      path: "/fantasy/myfantasy/complete",
      element: <PrivateRoute Component={MyFantasy} />,
    },
    {
      path: "/fantasy/myfantasy/details",
      element: <PrivateRoute Component={MyFantasyDetails} />,
    },
    {
      path: "/fantasy/myfantasy/matchup",
      element: <PrivateRoute Component={MyFantasyMatchup} />,
    },
    {
      path: "/fantasy/myfantasy/opponent",
      element: <PrivateRoute Component={MyFantasyOpponent} />,
    },
    {
      path: "/fantasy/myfantasy/standing",
      element: <PrivateRoute Component={MyFantasyStanding1} />,
    },
    {
      path: "/fantasy/myfantasy/upcoming/details/:contest_id",
      element: <PrivateRoute Component={MyFantasyUpcomingDetails} />,
    },
    {
      path: "/fantasy/multi-round/invite-friend",
      element: <PrivateRoute Component={InviteFriends1} />,
    },
    {
      path: "/fantasy/myfantasy/matchup",
      element: <PrivateRoute Component={MyFantasyMatchUp} />,
    },
    {
      path: "/fantasy/myfantasy/complete",
      element: <PrivateRoute Component={MyFantasyComplete} />,
    },
    {
      path: "/fantasy/myfantasy/upcoming",
      element: <PrivateRoute Component={MyFantasyUpcoming} />,
    },
    {
      path: "/fantasy/myfantasy/standing",
      element: <PrivateRoute Component={MyFantasyMatchUp} />,
    },
    {
      path: "/fantasy/myfantasy/portfoliodetails",
      element: <PrivateRoute Component={MyFantasyPortfolioDetails} />,
    },
    {
      path: "/fantasy/myfantasy/stockPreview",
      element: <PrivateRoute Component={MyFantasyEditStockPortfolio} />,
    },
    {
      path: "/fantasy/myfantasy/stockSelection",
      element: <PrivateRoute Component={MyFantasyStockPortfolioSelection} />,
    },
    {
      path: "/fantasy/myfantasy/portfolioPreview",
      element: <PrivateRoute Component={MyFantasyStockPortfolioPreview} />,
    },
    {
      path: "/fantasy/myfantasy/chat",
      element: <PrivateRoute Component={MyFantasyChat} />,
    },
    { path: "/home/quiz", element: <PrivateRoute Component={Quiz} /> },
    {
      path: "/home/quiz-round",
      element: <PrivateRoute Component={QuizRound} />,
    },
    {
      path: "/home/quiz-history/:index",
      element: <PrivateRoute Component={QuizHistory} />,
    },
    // {
    //   path: "/globalleaderboard/league",
    //   element: <PrivateRoute Component={LeaderboardLeague} />,
    // },
    // {
    //   path: "/globalleaderboard/contest",
    //   element: <PrivateRoute Component={LeaderboardContest} />,
    // },
    {
      path: "/home/profile/insights/:pageCode",
      element: <PrivateRoute Component={RalluBullsInsights} />,
    },
    {
      path: "/home/profile/setting/:pageCode",
      element: <PrivateRoute Component={DynamicContent} />,
    },
    {
      path: "*",
      element: <SharedRouteFallback deviceToken={deviceToken} />,
    },
  ];

  return (
    <section className="page">
      <React.Suspense fallback={<span />}>
        <Router forceRefresh={true}>
          <Routes>
            {routes?.map((route, index) => (
              <Route key={index} path={route?.path} element={route?.element} />
            ))}
          </Routes>
        </Router>
      </React.Suspense>
    </section>
  );
}

export default DefaultRoutes;

// <Routes>
// <Route path="/" element={<Login deviceToken={deviceToken} />} />
// <Route path="/register" element={<Login />} />
// <Route path="/otp" element={<Otp />} />
// <Route path="/home" element={<PrivateRoute Component={Home} />} />
// <Route
//   path="/toro-chat"
//   element={<PrivateRoute Component={ToroAIchat} />}
// />
// <Route
//   path="/home/profile"
//   element={<PrivateRoute Component={MyProfile} />}
// />
// <Route
//   path="/home/profile/badges"
//   element={<PrivateRoute Component={AllBadges} />}
// />
// <Route
//   path="/home/profile/certificate"
//   element={<PrivateRoute Component={AllCertificates} />}
// />
// <Route
//   path="/home/profile/recently-played"
//   element={<PrivateRoute Component={RecentlyPlayed} />}
// />
// <Route
//   path="/home/profile/subscription-history"
//   element={<PrivateRoute Component={SubscriptionHistory} />}
// />
// <Route path="/news" element={<PrivateRoute Component={News} />} />
// <Route
//   path="/community"
//   element={<PrivateRoute Component={Community} />}
// />
// <Route
//   path="/home/profile/plus/select-payment"
//   element={<PrivateRoute Component={SelectPayment} />}
// />
// <Route
//   path="/home/profile/plus/applied-coupon"
//   element={<PrivateRoute Component={AppliedCoupon} />}
// />
// <Route
//   path="/home/profile/plus/select-voucher"
//   element={<PrivateRoute Component={SelectVoucher} />}
// />
// <Route
//   path="/home/profile/trophy"
//   element={<PrivateRoute Component={Trophy} />}
// />
// <Route
//   path="/home/profile/invite"
//   element={<PrivateRoute Component={InviteFriend} />}
// />
// <Route
//   path="/home/profile/contact-us"
//   element={<PrivateRoute Component={ContactUs} />}
// />
// <Route
//   path="/home/profile/wallet"
//   element={<PrivateRoute Component={Wallet} />}
// />
// <Route
//   path="/home/profile/setting/FAQS"
//   element={<PrivateRoute Component={Faq} />}
// />
// <Route
//   path="/home/profile/earn/daily-rewards"
//   element={<PrivateRoute Component={DailyRewards} />}
// />
// <Route
//   path="/home/profile/earn/rewards"
//   element={<PrivateRoute Component={MyDailyRewards} />}
// />
// <Route
//   path="/home/profile/support"
//   element={<PrivateRoute Component={Support} />}
// />
// <Route
//   path="/home/profile/rate"
//   element={<PrivateRoute Component={Rateing} />}
// />
// <Route
//   path="/home/profile/leaderboard/contest"
//   element={<PrivateRoute Component={GlobalLeaderboardContest} />}
// />
// <Route
//   path="/home/profile/leaderboard/league"
//   element={<PrivateRoute Component={GlobalLeaderboardLeague} />}
// />
// <Route
//   path="/home/profile/spin-wheel"
//   element={<PrivateRoute Component={Spinwheel} />}
// />
// <Route
//   path="/home/profile/shop"
//   element={<PrivateRoute Component={Shop} />}
// />
// <Route
//   path="/home/profile/shop/giftcard"
//   element={<PrivateRoute Component={GiftCards} />}
// />
// <Route
//   path="/home/profile/shop/saved-voucher"
//   element={<PrivateRoute Component={SavedVoucher} />}
// />
// <Route
//   path="/home/profile/shop/productdetail"
//   element={<PrivateRoute Component={ProductDetails} />}
// />
// <Route
//   path="/home/profile/redeem-product"
//   element={<PrivateRoute Component={RedeemProduct} />}
// />
// <Route
//   path="/home/profile/earn/coin"
//   element={<PrivateRoute Component={EarnCoin} />}
// />
// <Route
//   path="/home/profile/plus"
//   element={<PrivateRoute Component={Subscription} />}
// />
// <Route
//   path="/home/edit-profile"
//   element={<PrivateRoute Component={EditProfile} />}
// />
// <Route
//   path="/home/edit-profile/avtarCategorylist"
//   element={<PrivateRoute Component={AvtarCategoryList} />}
// />
// <Route
//   path="/home/edit-profile/avtarlist/:id"
//   element={<PrivateRoute Component={AvtarList} />}
// />
// <Route
//   path="/home/profile/recent-played"
//   element={<PrivateRoute Component={MyProfileRecentContest} />}
// />
// <Route
//   path="/home/profile/recent-played-fantasy"
//   element={<PrivateRoute Component={MyProfileRecentFantasy} />}
// />
// <Route
//   path="/contest/games"
//   element={<PrivateRoute Component={Games} />}
// />
// <Route
//   path="/contest/games/contestdetails"
//   element={<PrivateRoute Component={ContestGameDetails} />}
// />
// <Route
//   path="/contest/games/tierSelection"
//   element={<PrivateRoute Component={GameTierSelection} />}
// />
// <Route path="/lms" element={<PrivateRoute Component={Lms} />} />
// <Route
//   path="/lms/my-course"
//   element={<PrivateRoute Component={LMSMyCourse} />}
// />
// <Route
//   path="/lms/course/:id"
//   element={<PrivateRoute Component={LMSCourseDetails} />}
// />
// <Route
//   path="/lms/payment"
//   element={<PrivateRoute Component={LMSPayment} />}
// />
// <Route
//   path="/lms/guide/:lessionId"
//   element={<PrivateRoute Component={LMSGuideRead} />}
// />
// <Route
//   path="/lms/common"
//   element={<PrivateRoute Component={LMSGuideCommon} />}
// />
// <Route
//   path="/lms/guide/:lessionId"
//   element={<PrivateRoute Component={LMSGuideVideo} />}
// />
// <Route
//   path="/lms/guide"
//   element={<PrivateRoute Component={LMSGuideQuestion} />}
// />
// <Route
//   path="/lms/guide-download"
//   element={<PrivateRoute Component={LMSGuideDownload} />}
// />
// <Route
//   path="/contest"
//   element={<PrivateRoute Component={Contest} />}
// />
// <Route
//   path="/contest/league/:id"
//   element={<PrivateRoute Component={ContestDetails} />}
// />
// <Route
//   path="/contest/info"
//   element={<PrivateRoute Component={ContestFantasyInfo} />}
// />
// <Route
//   path="/contest/selection"
//   element={<PrivateRoute Component={ContestSelection} />}
// />
// <Route
//   path="/contest/lineup"
//   element={<PrivateRoute Component={Lineup} />}
// />
// <Route
//   path="/contest/lineup/crypto"
//   element={<PrivateRoute Component={LineupCrypto} />}
// />
// <Route
//   path="/contest/portfolio/preview"
//   element={<PrivateRoute Component={ContestPortfolioPreview} />}
// />
// <Route
//   path="/contest/private"
//   element={<PrivateRoute Component={Contest} />}
// />
// <Route
//   path="/contest/private/add"
//   element={<PrivateRoute Component={AddPrivateContest} />}
// />
// <Route
//   path="/fantasy/invite-friend"
//   element={<PrivateRoute Component={InviteFriends} />}
// />
// <Route
//   path="/contest/join"
//   element={<PrivateRoute Component={JoinContest} />}
// />
// <Route
//   path="/contest/mycontest"
//   element={<PrivateRoute Component={MyContest} />}
// />
// <Route
//   path="/contest/mycontest/details"
//   element={<PrivateRoute Component={MyContestDetails} />}
// />
// <Route
//   path="/contest/mycontest/matchup"
//   element={<PrivateRoute Component={MyContestMatchup} />}
// />
// <Route
//   path="/contest/mycontest/opponent"
//   element={<PrivateRoute Component={MyContestOpponent} />}
// />
// <Route
//   path="/contest/mycontest/standing"
//   element={<PrivateRoute Component={MyContestStanding} />}
// />
// <Route
//   path="/contest/mycontest/upcoming"
//   element={<PrivateRoute Component={MyContest} />}
// />
// <Route
//   path="/contest/mycontest/upcoming/details/:contest_id"
//   element={<PrivateRoute Component={MyContestUpcomingDetails} />}
// />
// <Route
//   path="/contest/mycontest/complete"
//   element={<PrivateRoute Component={MyContest} />}
// />
// <Route
//   path="/paper"
//   element={<PrivateRoute Component={Paperless} />}
// />
// <Route
//   path="/paper/createportfolio"
//   element={<PrivateRoute Component={CreatePortfolio} />}
// />
// <Route
//   path="/toro-generated-portfolio-preview/:id"
//   element={
//     <PrivateRoute Component={ToroGeneratedPortfolioPreview} />
//   }
// />
// <Route
//   path="/home/marketPreview"
//   element={<PrivateRoute Component={MarketPreview} />}
// />
// <Route
//   path="/paper/portfoliolist"
//   element={<PrivateRoute Component={PortfolioListing} />}
// />
// <Route
//   path="/paper/portfolio/preview"
//   element={<PrivateRoute Component={PortfolioPreview} />}
// />
// <Route
//   path="/paper/portfolio/preview/stockdetails"
//   element={
//     <PrivateRoute Component={PortfolioPreviewStockDetails} />
//   }
// />
// <Route
//   path="/paper/info/trading-rules"
//   element={<PrivateRoute Component={TradingInfoDetails} />}
// />
// <Route
//   path="/paper/portfolio/stats"
//   element={<PrivateRoute Component={PortfolioStats} />}
// />
// <Route
//   path="/fantasy/multi-round"
//   element={<PrivateRoute Component={MultiRoundFantasy} />}
// />
// <Route
//   path="/fantasy/multi-round/leaguedetail/:id"
//   element={
//     <PrivateRoute Component={MultiRoundFantasyLeageDetails} />
//   }
// />
// <Route
//   path="/fantasy/multi-round/private"
//   element={<PrivateRoute Component={MultiRoundFantasy} />}
// />
// <Route
//   path="/fantasy/multi-round/create"
//   element={<PrivateRoute Component={MultiRoundCreateFantasy} />}
// />
// <Route
//   path="/fantasy/multi-round/join"
//   element={<PrivateRoute Component={MultiRoundJoinFantasy} />}
// />
// <Route
//   path="/fantasy/multi-round/roster"
//   element={<PrivateRoute Component={MultiRoundFantasyRoster} />}
// />
// <Route
//   path="/fantasy/multi-round/lineup"
//   element={<PrivateRoute Component={MultiRoundFantasyLineup} />}
// />
// <Route
//   path="/fantasy/multi-round/selection"
//   element={<PrivateRoute Component={MultiRoundFantasySelection} />}
// />
// <Route
//   path="/fantasy/multi-round/portfolioPreview"
//   element={
//     <PrivateRoute Component={MultiRoundFantasyPortfolioDetails} />
//   }
// />
// <Route
//   path="/fantasy/multi-round/myfantasy"
//   element={<PrivateRoute Component={MultiRoundMyFantasy} />}
// />
// <Route
//   path="/fantasy/myfantasy/multi-round/matchup"
//   element={<PrivateRoute Component={MultiRoundMyFantasyMatchUp} />}
// />
// <Route
//   path="/fantasy/myfantasy/multi-round/matchup-details"
//   element={
//     <PrivateRoute Component={MultiRoundMyFantasyMatchUpDeatils} />
//   }
// />
// <Route
//   path="/fantasy/myfantasy/multi-round/my-roster"
//   element={<PrivateRoute Component={MultiRoundMyFantasyMyRoster} />}
// />
// <Route
//   path="/fantasy/multi-round/myfantasy/complete"
//   element={<PrivateRoute Component={MultiRoundMyFantasyComplete} />}
// />
// <Route
//   path="/fantasy/multi-round/myfantasy/upcoming"
//   element={<PrivateRoute Component={MultiRoundMyFantasyUpcoming} />}
// />

// <Route
//   path="/fantasy"
//   element={<PrivateRoute Component={Fantasy} />}
// />
// <Route
//   path="/fantasy/info"
//   element={<PrivateRoute Component={SingleFantasyInfo} />}
// />
// <Route
//   path="/fantasy/leaguedetail/:id"
//   element={<PrivateRoute Component={LeageDetails} />}
// />
// <Route
//   path="/fantasy/lineup"
//   element={<PrivateRoute Component={FantasyLineup} />}
// />
// <Route
//   path="/fantasy/lineup/crypto"
//   element={<PrivateRoute Component={FantasyLineupCrypto} />}
// />
// <Route
//   path="/fantasy/selection"
//   element={<PrivateRoute Component={Selection} />}
// />
// <Route
//   path="/fantasy/bench-stock"
//   element={<PrivateRoute Component={FantasyBenchStock} />}
// />
// <Route
//   path="/fantasy/portfolio"
//   element={<PrivateRoute Component={FantasyPortfolioDetails} />}
// />
// <Route
//   path="/fantasy/create"
//   element={<PrivateRoute Component={CreateFantasy} />}
// />
// <Route
//   path="/fantasy/join"
//   element={<PrivateRoute Component={JoinFantasy} />}
// />
// <Route
//   path="/fantasy/private"
//   element={<PrivateRoute Component={Fantasy} />}
// />
// <Route
//   path="/fantasy/myfantasy"
//   element={<PrivateRoute Component={MyFantasy} />}
// />
// <Route
//   path="/fantasy/myfantasy/upcoming"
//   element={<PrivateRoute Component={MyFantasy} />}
// />
// <Route
//   path="/fantasy/myfantasy/complete"
//   element={<PrivateRoute Component={MyFantasy} />}
// />

// <Route
//   path="/fantasy/myfantasy/details"
//   element={<PrivateRoute Component={MyFantasyDetails} />}
// />
// <Route
//   path="/fantasy/myfantasy/matchup"
//   element={<PrivateRoute Component={MyFantasyMatchup} />}
// />
// <Route
//   path="/fantasy/myfantasy/opponent"
//   element={<PrivateRoute Component={MyFantasyOpponent} />}
// />
// <Route
//   path="/fantasy/myfantasy/standing"
//   element={<PrivateRoute Component={MyFantasyStanding1} />}
// />
// <Route
//   path="/fantasy/myfantasy/upcoming/details/:contest_id"
//   element={<PrivateRoute Component={MyFantasyUpcomingDetails} />}
// />
// <Route
//   path="/fantasy/multi-round/invite-friend"
//   element={<PrivateRoute Component={InviteFriends1} />}
// />

// <Route
//   path="/fantasy/myfantasy/matchup"
//   element={<PrivateRoute Component={MyFantasyMatchUp} />}
// />
// <Route
//   path="/fantasy/myfantasy/complete"
//   element={<PrivateRoute Component={MyFantasyComplete} />}
// />
// <Route
//   path="/fantasy/myfantasy/upcoming"
//   element={<PrivateRoute Component={MyFantasyUpcoming} />}
// />

// <Route
//   path="/fantasy/myfantasy/standing"
//   element={<PrivateRoute Component={MyFantasyMatchUp} />}
// />
// <Route
//   path="/fantasy/myfantasy/portfoliodetails"
//   element={<PrivateRoute Component={MyFantasyPortfolioDetails} />}
// />
// <Route
//   path="/fantasy/myfantasy/stockPreview"
//   element={<PrivateRoute Component={MyFantasyEditStockPortfolio} />}
// />
// <Route
//   path="/fantasy/myfantasy/stockSelection"
//   element={
//     <PrivateRoute Component={MyFantasyStockPortfolioSelection} />
//   }
// />
// <Route
//   path="/fantasy/myfantasy/portfolioPreview"
//   element={
//     <PrivateRoute Component={MyFantasyStockPortfolioPreview} />
//   }
// />
// <Route
//   path="/fantasy/myfantasy/chat"
//   element={<PrivateRoute Component={MyFantasyChat} />}
// />
// <Route
//   path="/home/quiz"
//   element={<PrivateRoute Component={Quiz} />}
// />
// <Route
//   path="/home/quiz-round"
//   element={<PrivateRoute Component={QuizRound} />}
// />
// <Route
//   path="/home/quiz-history/:index"
//   element={<PrivateRoute Component={QuizHistory} />}
// />
// <Route
//   path="/globalleaderboard/league"
//   element={<PrivateRoute Component={LeaderboardLeague} />}
// />
// <Route
//   path="/globalleaderboard/contest"
//   element={<PrivateRoute Component={LeaderboardContest} />}
// />
// <Route
//   path="/home/profile/insights/:pageCode"
//   element={<PrivateRoute Component={RalluBullsInsights} />}
// />

// <Route
//   path="/home/profile/setting/:pageCode"
//   element={<PrivateRoute Component={DynamicContent} />}
// />
// </Routes>
